import { Component, OnDestroy, OnInit } from '@angular/core';
import { SettingsService } from '@core';
import { Subscription } from "rxjs";

@Component({
  selector: 'Teranet-Base',
  template: ""
})
export abstract class BaseComponent implements OnInit, OnDestroy {

  public subscription: Subscription;

  constructor(protected settings: SettingsService) {

    this.TODO_winResize(); // Listening SideNav to get toggle

  }

  ngOnInit() {

  }

  TODO_winResize() {
    this.subscription = this.settings.notice.subscribe(data => {
      window.dispatchEvent(new Event('resize'));
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
